export default __webpack_public_path__ + "static/media/RadiationImg.ee276edb.jpg";